import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateService } from '@ngx-translate/core';
import { TranslationType } from './localization.types';

export class ConnectedMissingTranslationHandler implements MissingTranslationHandler {
  handle(parameters: MissingTranslationHandlerParams) {
    const translate = parameters.translateService;
    if (parameters.key.startsWith('reports.documentTypes.')) {
      return parameters.key.replace('reports.documentTypes.', '').replace('_', ' ');
    } else if (/^sensors\..*$/.test(parameters.key)) {
      const defaultLangTranslation = translate.parser.getValue(translate.translations[translate.defaultLang], parameters.key);
      return defaultLangTranslation || parameters.key.replace('sensors.', '');
    } else if (/^maintenance\.performance\.data/i.test(parameters.key)) {
      const defaultLangTranslation = translate.parser.getValue(translate.translations[translate.defaultLang], parameters.key);
      return defaultLangTranslation || parameters.key.replace(/^maintenance\.performance\.data/i, '');
    } else if (/^maintenance\.incidents\.data/i.test(parameters.key)) {
      const defaultLangTranslation = translate.parser.getValue(translate.translations[translate.defaultLang], parameters.key);
      return defaultLangTranslation || parameters.key.replace(/^maintenance\.incidents\.data/i, '');
    } else if (/^sensorgroup\..*$/.test(parameters.key)) {
      return parameters.key.replace('sensorgroup.', '');
    } else if (parameters.key.startsWith('kpiLabels.')) {
      return translate.instant(parameters.key.replace('kpiLabels.', 'upProjectLabels.'));
    } else if (parameters.key.startsWith(TranslationType.ChartTemplate)) {
      return this.capitalize(parameters.key.slice(Math.max(0, TranslationType.ChartTemplate.length + 1)).replaceAll('_', ' '));
    } else if (parameters.key.startsWith(TranslationType.PowerBiReport)) {
      return this.capitalize(parameters.key.slice(Math.max(0, TranslationType.PowerBiReport.length + 1)).replaceAll('_', ' '));
    } else if (parameters.key.startsWith('powerBiReportGlobal.')) {
      return this.capitalize(parameters.key.replace('powerBiReportGlobal.', '').replaceAll('_', ' '));
    } else if (parameters.key.startsWith(TranslationType.SpiderVisu)) {
      return this.capitalize(
        parameters.key
          .slice(Math.max(0, TranslationType.SpiderVisu.length + 1))
          .replaceAll('_', ' ')
          .toLocaleUpperCase(),
      );
    } else if (parameters.key.startsWith(TranslationType.Visualization)) {
      return this.capitalize(
        parameters.key
          .slice(Math.max(0, TranslationType.Visualization.length + 1))
          .replaceAll('_', ' ')
          .toLocaleUpperCase(),
      );
    } else if (parameters.key.startsWith('addonUsers.permissions.Smartenance.')) {
      return this.getDefaultLangTranslation(translate, parameters);
    } else if (parameters.key.startsWith('addonUsers.permissions.')) {
      return parameters.key.replace(/addonUsers\.permissions\.\w+\./, '');
    } else if (parameters.key.startsWith('jobsiteReport.businessUnitSelectionDialog.values.')) {
      return parameters.key.replace(/jobsiteReport\.businessUnitSelectionDialog\.values\.\w+\./, '');
    } else if (parameters.key.startsWith('jobsiteReport.jobsiteReportStatusSelectionDialog.values.')) {
      return parameters.key.replace(/jobsiteReport\.jobsiteReportStatusSelectionDialog\.values\.\w+\./, '');
    } else if (parameters.key.startsWith('addonUsers.userGroupSets.')) {
      return parameters.key.replace('addonUsers.userGroupSets.', '');
    } else {
      return this.getDefaultLangTranslation(translate, parameters);
    }
  }

  getDefaultLangTranslation(translate: TranslateService, parameters: MissingTranslationHandlerParams): string {
    return translate.parser.interpolate(
      translate.parser.getValue(translate.translations[translate.defaultLang], parameters.key),
      parameters.interpolateParams,
    ) as string;
  }

  capitalize(string_: string) {
    return string_
      .trim()
      .split(' ')
      .map((word) => {
        return word[0]?.toUpperCase() + word.slice(1);
      })
      .join(' ');
  }
}
